export default "__VITE_ASSET__sggGcEE3__"